export type SuccessResponse<T> = {
  success: true
  data: T
}

export type ErrorResponse = {
  success: false
  error: unknown
}

export const isSuccess = <T>(
  response: SuccessResponse<T> | ErrorResponse,
): response is SuccessResponse<T> => 'data' in response

export const isError = <T>(
  response: SuccessResponse<T> | ErrorResponse,
): response is ErrorResponse => 'error' in response

export type GetSnapshotReturnType<T> = SuccessResponse<T> | ErrorResponse

export type FirebaseList<T> = Record<number, T>
